import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import AddPartner from '../components/modals/AddPartner';
import EditPartner from '../components/modals/EditPartner';
import { useDispatch, useSelector } from 'react-redux';
import { deletePartnerAction, getPartnersAction } from '../redux/actions/partnersAction';
import { showStatus, toTitleCase } from '../utils/utils';
import UserDetailsModal from '../components/modals/UserDetailsModal';


const Partners = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const config = getConfig();

  const intialState = { partners: [], reqUserId: '', showUserDetailsModal: false }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, partners } = useSelector((state) => state.partners)
  const deletePartner = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeletePartner(id);
      }
    });
  }

  const confirmDeletePartner = async (id) => {
    const data = { id }
    dispatch(deletePartnerAction(data, config, getPartners))
  }

  const getPartners = async () => {
    dispatch(getPartnersAction(config))
  }

  useEffect(() => {
    getPartners();
  }, []);

  const onUserIdClick = (userId) => {
    setState({ reqUserId: userId, showUserDetailsModal: true })
  }

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Partners</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Client ID</th>
                <th scope="col">Aadhar</th>
                <th scope="col">PAN</th>
                <th scope="col">Bank account</th>
                <th scope="col">IFSC code</th>
                <th scope="col">Registered date</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(partners || []).map((partner) => {
                const { _id, name, email, phone, status, createdAt, aadharNumber, panNumber, bankAccountNumber, ifscCode, clientId, userId } = partner;
                return (
                  <tr key={_id}>
                    <td className='cursor-pointer' onClick={() => onUserIdClick(userId)}>{name}</td>
                    <td>{email || '-'}</td>
                    <td>{phone || '-'}</td>
                    <td>{clientId || '-'}</td>
                    <td>{aadharNumber || '-'}</td>
                    <td>{panNumber || '-'}</td>
                    <td>{bankAccountNumber || '-'}</td>
                    <td>{ifscCode || '-'}</td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td>{showStatus(status)}</td>
                    <td className='actions-container'>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' onClick={() => setState({ openEditPartnerModal: true, partnerId: _id })} disabled={loading}>
                        <i className='fa fa-pencil' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deletePartner(_id)} disabled={loading}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      <AddPartner
        key={() => new Date()}
        isOpen={state?.openAddPartnerModal}
        toggle={() => setState({ openAddPartnerModal: false })}
        getPartners={getPartners}
        loading={loading}
      />

      <EditPartner
        key={() => new Date()}
        isOpen={state.openEditPartnerModal}
        toggle={() => setState({ openEditPartnerModal: false, partnerId: null })}
        partnerId={state.partnerId}
        partners={partners || []}
        getPartners={getPartners}
        loading={loading}
      />

      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div >
  )
}

export default Partners